import i18n from '@/locales/index.js'
export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${i18n.t(pageTitle)}`
  }
  return ''
}
